import { render } from "./ElectionVoteElecomCivilianView.vue?vue&type=template&id=59cf954c"
import script from "./ElectionVoteElecomCivilianView.vue?vue&type=script&lang=js"
export * from "./ElectionVoteElecomCivilianView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Mobile\\voting2024\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__